export default __webpack_public_path__ + "static/media/c5.7be43d6e.jfif";